/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const Container = styled.div({
  display: 'grid',
  gridTemplate: "'avatar-area editor-area' / auto 1fr",
  position: 'relative',
});

export const AvatarSection = styled.div({
  gridArea: 'avatar-area',
  marginRight: '8px',
});

export const EditorSection = styled.div({
  gridArea: 'editor-area',
  minWidth: 0,
});

export const SummaryLabelContainer = styled.div({
  marginTop: token('space.100', '8px'),
});

// Overwrite border radius of AiOptIn component to match the border radius of the Modal
export const AiOptInContainer = styled.div({
  '> div': {
    borderRadius: '3px !important',
  },
});
